module.exports = __webpack_public_path__ + "static/img/Noise_N.0d710ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_N.png
// module id = HD75
// module chunks = 1